import React from 'react';
import { Responsive, SimpleList, Filter, List, Edit, Create, Datagrid, ShowButton, SimpleForm, TextInput,
TextField, Toolbar, SaveButton, required,
SimpleShowLayout, Show, ArrayField, SingleFieldList,
ChipField, SelectField, NumberField, BooleanField, Pagination  } from 'react-admin';
//import { TextField as MUTextField } from 'redux-form-material-ui'
import SchemaVis from 'react-jsonschema-vis';
import components from './pkadmin/vis_components';
import path_to_schemas_user_questions_schema_json from './actions/schemas/user_questions.schema.json';
import { ArrayToStringField } from './pkadmin/components/ArrayToStringField'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Title } from 'react-admin';

import { resources_by_name } from './pkadmin/resources.js'

//props && props.setFilters(values)
/*onBlur={(event)=>{
  console.log("inputblur", event)
    console.log("inputblur", props)
  props && props.setFilters(props.filterValues)
}
<Button type="submit" alwaysOn onClick={(event)=>(props && props.setFilters(props.filterValues))}>SEARCH</Button>
}*/
const SurveyquestionsFilter = (props) => {
    return ( <Filter {...props} >
        <TextInput label="Search" source="q" alwaysOn />
        <TextInput source="name"/>
    </Filter> )
  }

const SurveyquestionsListTitle = ({ record }) => {
    return <span>Survey Questions</span>;
};


export const SurveyquestionsListPublic = (props) => {
    return (
      <Card>
        <Title title="Survey Science" />
        <CardContent>
        <h3>Thank you for participating!</h3>
        </CardContent>
    </Card>
  )
};

const PostPagination = props => {
  console.log("PostPagination.props", props)
  return <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
}

export const ProfilesSearchList = (props) => (
    <List
          title={<SurveyquestionsListTitle />}
          {...props}
          filters={<SurveyquestionsFilter />}
          debounce="700"
          pagination={<PostPagination />}
          >
        <Responsive
            small={

                <SimpleList
                    primaryText={record => record.id}
                    secondaryText={record => record.firstnames +", "+record.familynames}
                    tertiaryText={record => record.subjects.join(', ')}/>
            }
            medium={
                <Datagrid>
                     <TextField source="firstnames" label="First Name"/>
                     <TextField source="familynames" label="Family Name"/>
                     <ArrayToStringField source="subjects" label="Subjects"/>

                    <ShowButton />
                </Datagrid>
            }
        />
    </List>
);

const PostCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const SurveyquestionsCreateEditTitle = ({ record }) => {
    return <span>Survey Questions for {record ? `"${record.title}"` : ''}</span>;
};


export const SurveyquestionsEdit = (props) => {
    return <Edit title={<SurveyquestionsCreateEditTitle />}  {...props}>
        <SimpleForm redirect="list" toolbar={<PostCreateToolbar/>}>
            <SchemaVis form="surveyquestions_edit_form" schema={path_to_schemas_user_questions_schema_json} components={components}/>

        </SimpleForm>
    </Edit>
};

export const SurveyquestionsCreate = (props) => (
    <Create title={<SurveyquestionsCreateEditTitle />}  {...props}>
        <SimpleForm>

        </SimpleForm>
    </Create>
);

export const AdminProfileShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
          <TextField
            className="md-cell md-cell--top"
            label="First Names"
            name="firstnames"
            validate={required('Required')}
            source="firstnames"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            className="md-cell md-cell--top"
            label="Family Names"
            name="familynames"
            validate={required('Required')}
            source="familynames"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            className="md-cell md-cell--top"
            label="Contact Email"
            name="email"
            validate={required('Required')}
            source="email"
            type="email"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            label="Contact Phone Number"
            name="phonenumber"
            validate={required('Required')}
            source="phonenumber"
            {...resources_by_name['profiles']['field_args']}/>
          <ArrayField source="subjects" label="Subjects">
              <SingleFieldList>
                  <ChipField source="name" />
              </SingleFieldList>
          </ArrayField>
          <SelectField label="Highest Education Achieved" source="highesteducationachieved" validate={required('Required')}
            choices={[
                { id: 'secondaryschool', name: 'Secondary School/High School' },
                { id: 'otherthirdlevel', name: "Other Post-Leaving Cert/Third Level Course" },
                { id: 'highercertificate', name: "Higher/Advanced Certificate" },
                { id: 'ordinarybachelor', name: "Ordinary Bachelor's Degree" },
                { id: 'bachelor', name: "Honours Bachelor's Degree" },
                { id: 'masters', name: "Master's Degree" },
                { id: 'phd', name: "PhD Degree" }
            ]} />
          <TextField
            label="Education Details (Optional)"
            name="education"
            source="education"
            {...resources_by_name['profiles']['field_args']}/>
          <TextField
            label="Work Experience Details (Optional)"
            name="workexperience"
            source="workexperience"
            {...resources_by_name['profiles']['field_args']}/>

          <NumberField
            helperText="Set the distance you're willing to travel from location specified (leave empty for no restriction)"
            label="Travel Distance"
            source="traveldistance"
            {...resources_by_name['profiles']['field_args']}/>
          <BooleanField
            label="Will travel with no restrictions if accomodation available"
            source="willtakeaccomodation"
          />
        </SimpleShowLayout>
    </Show>
);
